// Permite a qualquer ponto da interface (menu de ajuda, menu do avatar) pedir o tour de novo.
// `useTutorial` escuta este evento e reinicia os tutoriais sem alterar o que foi marcado como visto.
export const START_TOUR_EVENT = 'taskrush:start-tour'

export const startTour = () => {
  window.dispatchEvent(new Event(START_TOUR_EVENT))
}
